import React, { Fragment, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useMutation, useQuery } from 'react-query';
import classNames from 'classnames/bind';
import { useDispatch } from 'react-redux';
import Modal from '../../../components/Modal/Modal';
import apiClient from '../../../helpers/apiClient';
import styles from './assets/styles.scss';
import { successToast } from '../../../helpers/toast';
import { setAvatar } from '../../../redux/modules/auth';

import IconCheckmark from './assets/checkmark-icon.svg?inline';
import IconCamera from './assets/camera.svg?inline';
import Button from '../../../components/Button/Button';

const cx = classNames.bind(styles);

async function getAvatars() {
  return (await apiClient().get('/v1/common/profileimages')).data;
}
async function _updateAvatar(avatarId) {
  await apiClient().post('/v1/mypage/modify/profileimage', { image_id: avatarId });
}
export default function Avatar({ src }) {
  const dispatch = useDispatch();
  const [isOpen, setIsOpen] = useState(false);
  const [newAvatar, setNewAvatar] = useState(src);
  const { data: avatars = [] } = useQuery('avatars', getAvatars);
  const { mutate: updateAvatar, isLoading } = useMutation(({ id }) => _updateAvatar(id), {
    onSuccess: (data, { image_url: imageUrl }) => {
      successToast('Avatar updated successfully');
      dispatch(setAvatar(imageUrl));
      setIsOpen(false);
    },
  });

  // reset on modal close
  useEffect(() => {
    if (!isOpen) {
      setNewAvatar(src);
    }
  }, [isOpen]);

  return (
    <Fragment>
      <div className={cx('avatar-container')}>
        <img src={src} alt="avatar" />
        <button className={cx('hover-overlay')} type="button" onClick={() => setIsOpen(true)}>
          <IconCamera />
        </button>
      </div>
      <Modal
        header="Change Avatar"
        isOpen={isOpen}
        onClose={() => !isLoading && setIsOpen(false)}
        dark
        backgroundColor="#1F0D53"
        className={cx('change-avatar-modal')}
        footerContent={(
          <Button
            className={cx('save-button')}
            onClick={() => updateAvatar(avatars.find(({ image_url: imageUrl }) => imageUrl === newAvatar))}
            isDisabled={src === newAvatar}
            isLoading={isLoading}
          >
            Save
          </Button>
        )}
      >
        <div className={cx('avatar-list')}>
          {avatars.map(({ id, image_url: imageUrl }) => (
            <button key={id} type="button" onClick={() => setNewAvatar(imageUrl)}>
              <img src={imageUrl} alt={`avatar-${id}`} />
              {newAvatar === imageUrl && <IconCheckmark />}
            </button>
          ))}
        </div>
      </Modal>
    </Fragment>
  );
}
Avatar.propTypes = {
  src: PropTypes.string.isRequired,
};
